import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const MenuItem = ({
  item,
}) => {
  return (
    <div
      className={`${styles.menuItemWrapper}`}>
      <div className={styles.menuItemsList}>
        <div
          className={`${styles.menuItem}`}>
          {item?.name && <div className={item?.icon ==='small'? styles.itemTitle: styles.itemBraunTitle}><a href={item.url} target="_blank">{item.name}</a></div>}
        </div>
        </div>
        {item?.icon ==='small' ? 
        <div
          className={`${styles.menuTimelineIcon}`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path id="Layer0_36_MEMBER_1_1_STROKES" data-name="Layer0 36 MEMBER 1 1 STROKES" d="M9.53,9.54A4.82,4.82,0,0,1,6,11,4.82,4.82,0,0,1,2.47,9.54,4.83,4.83,0,0,1,1,6,4.82,4.82,0,0,1,2.46,2.47,4.83,4.83,0,0,1,6,1,4.83,4.83,0,0,1,9.54,2.47,4.82,4.82,0,0,1,11,6,4.83,4.83,0,0,1,9.53,9.54Z"
              style={{fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2px"}}/>
            </g>
          </g>
          </svg>
          </div>:
          <div
            className={`${styles.menuTimelineBigIcon}`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <g>
                  <path id="Layer0_36_MEMBER_1_1_STROKES" data-name="Layer0 36 MEMBER 1 1 STROKES" d="M14,14a4.13,4.13,0,0,1-3,1.26A4.3,4.3,0,0,1,6.71,11,4.3,4.3,0,0,1,11,6.71,4.3,4.3,0,0,1,15.29,11,4.13,4.13,0,0,1,14,14Z" style={{fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2px"}}/>
                  <path id="Layer0_36_MEMBER_1_1_STROKES-2" data-name="Layer0 36 MEMBER 1 1 STROKES" d="M18.06,18.07A9.62,9.62,0,0,1,11,21a9.62,9.62,0,0,1-7.06-2.93A9.63,9.63,0,0,1,1,11,9.62,9.62,0,0,1,3.93,3.94,9.63,9.63,0,0,1,11,1a9.63,9.63,0,0,1,7.07,2.94A9.62,9.62,0,0,1,21,11,9.63,9.63,0,0,1,18.06,18.07Z" style={{ fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2px"}}/>
                </g>
              </g>
            </g>
          </svg>
        </div>
        }
      </div>
  );
};

MenuItem.propTypes = {
  item: PropTypes.object
}

export default MenuItem;